/* eslint-disable no-nested-ternary */
import React from "react";
import { Pagination } from "@mui/material";
import { useWindowSize } from "react-use";

const CustomPagination = ({ pageTotal, handleChoosePage, page, disabled }) => {
  const { width } = useWindowSize();
  return (
    <Pagination
      count={pageTotal}
      showFirstButton={page === 0}
      showLastButton={page === pageTotal}
      onChange={(e, newPage) => handleChoosePage(e, newPage)}
      page={page}
      shape="rounded"
      variant="outlined"
      boundaryCount={1}
      siblingCount={width > 1536 ? 3 : width < 1536 && width > 768 ? 2 : 1}
      sx={{
        "& .MuiPagination-ul": {
          display: "flex",
          gap: "4px"
        }
      }}
      disabled={disabled}
    />
  );
};
export default CustomPagination;
